import { useTranslation } from 'react-i18next';
import { EPDStateModel } from 'services/EpdClient';
import styled from 'styled-components';

type TProps = {
  epdState: EPDStateModel | undefined | null;
};

const StatusBox = ({ epdState }: TProps) => {
  const { t } = useTranslation();
  const isEPDDepublishedByAdminOrDeclined =
    epdState?.statusMessageCode === 'declinedVerification' ||
    epdState?.statusMessageCode === 'depublishedEPDNotPaid' ||
    epdState?.statusMessageCode === 'depublishedEPDNonCompliant' ||
    epdState?.statusMessageCode === 'declinedPublication' ||
    epdState?.statusMessageCode === 'oldWizardDeclinedPublicationProcessCertification';

  const statusMessage = t(`epdWizard.epdState.statusMessage.${epdState?.statusMessageCode}`);
  const actionMessage = t(`epdWizard.epdState.actionMessage.${epdState?.statusMessageCode}`);

  return (
    <>
      <EpdStateContainer $isEPDDepublishedByAdminOrDeclined={isEPDDepublishedByAdminOrDeclined}>
        <EpdStateMessage>
          <b>
            <label>{t('epdWizard.epdState.title')}</label>
          </b>
          {statusMessage}
        </EpdStateMessage>
        <EpdStateMessage>
          <b>
            <label>{t('epdWizard.epdState.action.title')}</label>
          </b>
          {actionMessage}
        </EpdStateMessage>
      </EpdStateContainer>
      {epdState?.commentToStatus && isEPDDepublishedByAdminOrDeclined && (
        <EpdStateContainer $isEPDDepublishedByAdminOrDeclined={isEPDDepublishedByAdminOrDeclined}>
          <EpdStateMessage>
            <b>
              <label>
                {epdState?.statusMessageCode === 'declinedVerification'
                  ? t('epdWizard.epdState.action.commentByVerifierTitle')
                  : t('epdWizard.epdState.action.commentByAdminTitle')}
              </label>
            </b>
            {epdState?.commentToStatus}
          </EpdStateMessage>
        </EpdStateContainer>
      )}
    </>
  );
};

const EpdStateContainer = styled.div<{
  $isEPDDepublishedByAdminOrDeclined?: boolean;
}>`
  display: flex;
  flex-direction: row;
  background-color: ${(props) =>
    props?.$isEPDDepublishedByAdminOrDeclined
      ? props.theme.colors.statusLabelRedBgOldWizard
      : props.theme.colors.lightGreen};
  padding: 1rem;
  width: 100%;
  justify-content: space-between;
  margin-bottom: 1rem;
`;

const EpdStateMessage = styled.div`
  padding-right: 1rem;
  display: flex;
  flex-direction: column;

  label {
    font-style: normal;
    text-transform: uppercase;
    padding-bottom: 0.5rem;
    ${(props) => props.theme.fonts.textSmall}
  }
`;

export default StatusBox;
